// import { useEffect } from 'react';
import { useMemo, useEffect } from 'react';
import { setIsOpen } from "@/store/modules/user";
import { useSelector, useDispatch } from "react-redux";

const Oge = ({ id, url, type }) => {
	const dispatch = useDispatch()
	const { userInfo } = useSelector(state => state.user)
	const useName = useMemo(() => userInfo?.username, [userInfo])
	const password = useMemo(() => userInfo?.password, [userInfo])
	const lang = useMemo(() => {
		return localStorage.getItem("lang") || "en-US";
	}, []);
	useEffect(() => {
		if (useName && password) {
			dispatch(setIsOpen(false))
			const newPassword = password.replace(/\+/g, "!");
			const iframe = document.getElementById(id);
			iframe.src = `https://oge.ogeoa.net/${lang === "en-US" ? lang + "/" : ""}${url}?type=${type}&username=${useName}&password=${newPassword}`
		} else {
			// dispatch(setIsOpen(true))
			const iframe = document.getElementById(id);
			iframe.src = `https://oge.ogeoa.net/${lang === "en-US" ? lang + "/" : ""}${url}?type=${type}&lang=${lang}`
		}
	}, [dispatch, id, type, url, useName, password]);
	useEffect(() => {
		const handleMessage = (event) => {
			// 可以根据实际情况添加来源验证
			if (event.origin === 'https://oge.ogeoa.net') {
				if (event.data.message === 'login') {
					dispatch(setIsOpen(true))
				}
			}
		};
		window.addEventListener('message', handleMessage);
		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, []);
	return <iframe
		title="Oge"
		id={id}
		style={{ width: "calc(100% - 8px)", height: "calc(100vh - 10px)", marginTop: -80 }}
	>
	</iframe>
}
export default Oge;